import { useGetNotReportedShippingsWithReturnsIntakeListQuery } from '../../services/returnsIntake.endpoints';
import { ReturnsIntakeFilters } from '../../models';
import { extractDate, extractTime } from '@/utils';

interface UseNotReportedShippingsProps {
  filters: ReturnsIntakeFilters;
  page: number;
  pageSize: number;
}

export const useNotReportedShippings = ({
  filters,
  page,
  pageSize,
}: UseNotReportedShippingsProps) => {
  const { data, isLoading } = useGetNotReportedShippingsWithReturnsIntakeListQuery({
    filters,
    paginated: { page, pageSize },
  });

  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return '-';
    const date: string = extractDate(dateString);
    const time: string = extractTime(dateString);
    if (date === 'N/A' || date === 'Fecha inválida') return '-';
    return `${date} ${time}`;
  };

  return {
    shippings: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: Math.ceil((data?.count || 0) / pageSize),
    isLoading,
    formatDate,
  };
};
